import {AdvertSearchSummaryAdvertDTO} from "../AdvertSearchSummary";

export interface WatchlistAdvertDTO {
  advertId: string;
  customerId: string;
  advert: AdvertSearchSummaryAdvertDTO;
}
